<template>
  <b-modal
    v-model="isVisible"
    hide-footer
    @toggle="onCancel"
    size="xl"
  >
    <div v-if="!loadingData && dataForm">

      <h1 
        class="text-center mb-3"
      >
        {{ tipoInterconsulta === '1' 
          ? `${estadoInterconsulta === '1' ? 'Editar ' : 'Crear'} Solicitud de Interconsulta` 
          : `${estadoInterconsulta === '1' ? 'Editar ' : 'Crear'}  Informe Interconsultas`
        }}
      </h1>

      <div 
        class="mb-3"
        v-if="dataForm"
      >
      
        <b-card style="border: 1px solid #c9c9c9">
          <b-row>
            <span class="col-6 mb-1">
              <b>Paciente:</b> 
              {{ dataForm.paciente }}
            </span>

            <span class="col-6 mb-1">
              <b>Establecimiento:</b> 
              {{ dataForm.establecimiento.text }}
            </span>

            <span class="col-6 mb-1">
              <b>Doctor:</b> 
              {{ dataForm.doctor }}
            </span>

            <span class="col-6 mb-1">
              <b>Fecha Interconsulta:</b> 
              {{ dataForm.fechaInterconsulta }}
            </span>

          </b-row>
        </b-card>

        <b-card 
          style="border: 1px solid #C9c9c9"
          v-if="tipoInterconsulta === '1'"
        >
          <b-row>
            <div class="col-6 mb-1">
              <!-- <label for="">
                <span for="" class="text-danger">*</span>
                Fecha de interconsulta:
              </label>
              <flat-pickr
                class="form-control"
                v-model="dataForm.fechaInterconsulta"
                locale="es"
                placeholder="Seleccionar Fecha"
              />
              <small class="text-danger">{{ getErrorsText(errors.fecha) }}</small> -->
            </div>

            <div class="col-6 mb-1 my-2 d-flex align-items-center px-2" >
              <label> Es urgente? </label>
              <b-form-checkbox 
                switch 
                v-model = "dataForm.esUrgente"
                class="ml-2 mb-0"
              >
                {{ dataForm.esUrgente ? 'Si' : 'No' }}
              </b-form-checkbox>
              
            </div>

            <div class="col-6 mb-1">
              <label for="">
                <span for="" class="text-danger">*</span>
                Servicio:
              </label>
              <v-select
                v-model="dataForm.servicio"
                :options="servicioOpts"
                :reduce="option => option"
                label="text"
              />
              <small class="text-danger">{{ getErrorsText(errors.servicio) }}</small>
            </div>

            <div class="col-6 mb-1">
              <label for="">
                <label for="" class="text-danger">*</label>
                Especialidad:
              </label>
              <v-select
                v-model="dataForm.especialidad"
                :options="especialidadesOpts"
                :reduce="option => option"
                label="text"
              />
              <small class="text-danger">{{ getErrorsText(errors.especialidad) }}</small>
            </div>
            <div class="col-6">
              <label for="">
                <span for="" class="text-danger">*</span>
                Descripcion del Motivo:
              </label>
              <b-form-textarea v-model="dataForm.motivo" />
              <small class="text-danger">{{ getErrorsText(errors.motivo) }}</small>
            </div>
          </b-row>
        </b-card>
        <b-card style="border: 1px solid #C9c9c9">

          <b-row>
            <div class="col-12 mt-1">
              <label for="">Cuadro clinico actual:</label>
              <b-form-textarea rows="3" v-model="dataForm.cuadroClinico" />
            </div>

            <div 
              class="col-6 mt-1"
              v-if="tipoInterconsulta === '1'"
            >
              <label for="">Resultado de examenes:</label>
              <b-form-textarea v-model="dataForm.resultadoExamenes" />
            </div>

            
            <div 
              class="col-6 mt-1"
              v-if="tipoInterconsulta === '2'"
            >
              <label for="">Resumen del criterio clinico:</label>
              <b-form-textarea v-model="dataForm.criterioClinico" />
            </div>

            <div class="col-6 mt-1">
              <label for="">Plan terapeutico realizado:</label>
              <b-form-textarea v-model="dataForm.planTerapeutico" />
            </div>
            <div 
              class="col-6 mt-1"
              v-if="tipoInterconsulta === '2'"
            >
              <label for="">Plan de Diagnostico Propuesto:</label>
              <b-form-textarea v-model="dataForm.planDiagnostico" />
            </div>
          </b-row>
        </b-card>

        <DiagnosticosList 
          v-model="dataForm.diagnosticos"
          class="my-2"
          noAdd
          noEditItems
        />

      </div>
      <b-row>
        <b-col class="d-flex justify-content-end">
          <b-button
            variant="primary"
            @click="onSaveInterconsulta"
            class="m-2"
          >
            Guardar
          </b-button>
        </b-col>        
      </b-row>
    </div>
    <GeneralLoader v-if="loadingData" :size="'100'" class="my-5"/>
  </b-modal>
</template>

<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import vSelect from "vue-select";
import { especialidadService } from '@/shared/services';
import { DiagnosticosList, GeneralLoader } from '@/shared/components';
import 'flatpickr/dist/flatpickr.css';
import { interconsultaService } from '../../services';
import { interconsultaMapper, servicioOpts } from '../../helpers';
import { diagnosticosService } from "../../../atencionMedica/services/anamnesisService/diagnosticosService";


export default {

  name: "InterconsultaModalCompletar",

  components: {
    vSelect,
    DiagnosticosList,
    GeneralLoader
  },

  data(){
    return{
      isVisible: false,
      interconsultaCreated: false,
      validationFormCita: null,

      loadingData: false,

      tokenInterconsulta: null,
      paciente: null,

      dataForm:null,
      interconsultaInit:null,

      especialidadesOpts: [],
      servicioOpts: servicioOpts,

      errors:{
        fecha        :[],
        especialidad :[],
        servicio     :[],
        motivo       :[]
      }
    }
  },


  created() {
    this.tokenInterconsulta = this.$route.query.completar;
    this.loadDataInit();
  },


  methods: {

    async loadDataInit(){
      this.especialidadesOpts = await especialidadService.getOptionsSelect();
    },

    onCancel(){
      this.isVisible = false;
    },


    async onGetDataInterconsulta(tokenInterconsulta){
      this.loadingData = true;
      const data = await interconsultaService.getByToken(tokenInterconsulta);

      const isValidToken = this.onValidateToken(data);
      if (!isValidToken) return;

      this.isVisible = true;
      this.interconsultaInit = await interconsultaMapper( data );

      const estadoInterconsulta = this.interconsultaInit?.estado.value;
      const tokenAtencion       = this.interconsultaInit?.atencionMedica.token;

      const diagnosticos = (estadoInterconsulta !== '99')
        ? this.interconsultaInit.diagnosticos
        : await this.loadDiagnosticos(tokenAtencion);

      this.dataForm = {
        ...this.interconsultaInit,
        diagnosticos 
      }

      this.loadingData = false;

    },


    async loadDiagnosticos(tokenAtencion){
      const responseDiagnosticos = await diagnosticosService.getByAtencion(tokenAtencion)
      const diagnosticosActivos = responseDiagnosticos.filter( d => d.activo );
      return diagnosticosActivos;
    },


    onValidateToken(data){
      if (!data){
        this.$swal("Error", "La interconsulta no existe.", "error")
          .then(
            () => this.$router.push({ name: 'interconsultas' })
          );
        return false;
      }

      // if(data.estadoInterconsulta !== '99' ){
      //   this.$swal("Error", "La interconsulta ya fue completada.", "error")
      //     .then(
      //       () => this.$router.push({ name: 'interconsultas' })
      //     );
      //   return false;
      // }

      return true;
    },


    async onSaveInterconsulta(){

      const isValidForm = this.onValidateForm();

      if(!isValidForm){
        this.$swal({
          title: "Tienes campos necesarios por completar",
          icon: "warning",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "ok",
        });

        return;
      }

      const responseUpdate = await interconsultaService.update(this.dataForm);

      if(!responseUpdate) {
        this.$swal({
          title: "Error al actualizar la interconsulta",
          icon: "error",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "ok",
        });
        return;
      }

      const response = await this.$swal({
        title: `Interconsulta ${this.estadoInterconsulta === '1' ? 'editada' : 'creada'} correctamente`,
        icon: "success",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "ok",
      });

      if (response){
        this.$router.push({ name: 'interconsultas', query: { pending: this.interconsultaInit.atencionMedica.id } });
        this.$router.go()
      } 


    },

    onValidateForm(){

      if(this.tipoInterconsulta === '2') return true;
      
      this.errors.fecha        = [];
      this.errors.especialidad = [];
      this.errors.servicio     = [];
      this.errors.motivo       = [];

      const fecha        = this.dataForm.fechaInterconsulta;
      const especialidad = this.dataForm.especialidad;
      const servicio     = this.dataForm.servicio;
      const motivo       = this.dataForm.motivo;

      if(fecha === null || fecha === '' ){
        this.errors.fecha.push('Este campo es requerido');
      }

      if( especialidad === null || especialidad === '' ){
        this.errors.especialidad.push('Este campo es requerido');
      }

      if( servicio === null || servicio === '' ){
        this.errors.servicio.push('Este campo es requerido');
      }

      if( motivo === null || motivo === '' ){
        this.errors.motivo.push('Este campo es requerido');
      }

      if(
        this.errors.fecha.length > 0 
        || this.errors.especialidad.length > 0
        || this.errors.servicio.length > 0
        || this.errors.motivo.length > 0
      )
        return false;

      return true;
    },


    getErrorsText( errors ){
      if(errors.length === 0) return '';
      const errorsText = errors.join(', ');
      return errorsText
    }
  },

  computed: {

    estadoInterconsulta(){
      return this.dataForm?.estado.value
    },

    tipoInterconsulta(){
      return this.dataForm?.tipo.value 
    }
  },


  watch: {

    tokenInterconsulta:{
      deep: true,
      handler(newValue) {
        if (!newValue) return;
        this.onGetDataInterconsulta(newValue);
      }
    },

    '$route.query.completar': {
      handler(newValue) {
        this.tokenInterconsulta = newValue;
      }
    },

    isVisible: {
      deep: true,
      handler(newValue) {
        if( !newValue ) this.$router.push({ name: 'interconsultas' })
      }
    }
  },


}
</script>
